import styled from 'styled-components'

export default styled.div`
  font-size: 15px;
  padding: 10px;
  background: #dee0eb;
  border-radius: 3px;
  margin-bottom: 25px;
`
